/**
* 左边菜单
*/ 
<template>
  <div>
    <div class="logobox">
      <!-- <img class="logoimg" src="../assets/img/logo.png" alt="" /> -->
    </div>
    <el-row class="tac">
      <el-col>
        <el-menu
          unique-opened
          @select="handleSelect"
          :collapse="isCollapse"
          router
          default-active="/home/Home"
          class="el-menu-vertical-demo"
        >
          <!-- @open="handleOpen"
          @close="handleClose" -->
          <div class="logoBox">
            <img src="../assets/img/logo1.jpg" class="logo1" alt="" />
            <div>壹嘉国际</div>
          </div>
          <el-menu-item
            index="/home/Home"
            :class="pageRouter == '/home/Home' ? 'color1' : ''"
          >
            <i class="el-icon-s-home"></i>
            <span slot="title">首页</span>
          </el-menu-item>
          <el-menu-item index="/goods/Goods">
            <i class="el-icon-s-promotion"></i>
            <span slot="title">创建运单</span>
          </el-menu-item>

          <el-submenu index="/parcel">
            <template slot="title">
              <i class="el-icon-s-cooperation"></i>
              <span>我的包裹</span>
            </template>
             <el-menu-item index="/parcel/allOrder">• 全部包裹</el-menu-item>
            <el-menu-item index="/parcel/upcoming">• 未入库包裹</el-menu-item>
            <el-menu-item index="/parcel/nonPayment">• 未付款包裹</el-menu-item>
            <el-menu-item index="/parcel/storage">• 已入库包裹</el-menu-item>
            <el-menu-item index="/parcel/deliverDoods"
              >• 已发货包裹</el-menu-item
            >
            <el-menu-item index="/parcel/arrival">• 已到货包裹</el-menu-item>
            <el-menu-item index="/parcel/history">• 历史包裹</el-menu-item>
          </el-submenu>
          <el-submenu index="undetermined">
            <template slot="title">
              <i class="el-icon-s-order"></i>
              <span>
                待确认包裹
                <img
                  src="@/assets/img/dian.png"
                  alt=""
                  style="margin-bottom: 3px"
                  v-if="
                    sendGoods > 0 || confirmedNum > 0 || getWarehousesNumber > 0
                  "
                />
              </span>
            </template>
            <el-menu-item index="/undetermined/unmatch">
              <el-badge
                :value="getWarehousesNumber"
                class="item"
                v-if="getWarehousesNumber && getWarehousesNumber > 0"
                >• 未匹配包裹
              </el-badge>
              <span v-else> • 未匹配包裹</span>
            </el-menu-item>
            <el-menu-item index="/undetermined/unShipments"
              ><el-badge
                :value="sendGoods"
                class="item"
                v-if="sendGoods && sendGoods > 0"
              >
                • 待发货包裹
              </el-badge>
              <span v-else> • 待发货包裹</span></el-menu-item
            >
            <el-menu-item index="/undetermined/undetermined"
              ><el-badge
                :value="confirmedNum"
                class="item"
                v-if="confirmedNum && confirmedNum > 0"
                >• 待确认包裹</el-badge
              ><span v-else> • 待确认包裹</span></el-menu-item
            >
          </el-submenu>
          <el-submenu index="salessSeturn">
            <template slot="title">
              <i class="el-icon-s-release"></i>
              <span
                >退运中心
                <img
                  src="@/assets/img/dian.png"
                  alt=""
                  v-if="selectReturnOrderDatas.returnedCount > 0"
                  style="margin-bottom: 3px"
              /></span>
            </template>
            <el-menu-item index="/salessSeturn/applyFor"
              >• 申请退运包裹</el-menu-item
            >
            <el-menu-item index="/salessSeturn/await"
              >• 待退运包裹</el-menu-item
            >
            <el-menu-item index="/salessSeturn/accomplish">
              <el-badge
                :value="selectReturnOrderDatas.returnedCount"
                v-if="
                  selectReturnOrderDatas.returnedCount &&
                  selectReturnOrderDatas.returnedCount > 0
                "
                class="item"
              >
                • 已退运包裹
              </el-badge>
              <span v-else> • 已退运包裹</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="/extractGoods/extractGoods">
            <i class="el-icon-s-management"></i>
            <span slot="title">提货管理</span>
          </el-menu-item>
          <el-submenu index="/deliveryOrder">
            <template slot="title">
              <i class="el-icon-s-operation"></i>
              <span>派送订单</span>
            </template>
            <!-- <el-badge is-dot class="item"></el-badge> -->
            <el-menu-item index="/deliveryOrder/want">• 我要派送</el-menu-item>

            <el-menu-item index="/deliveryOrder/beBeing"
              >• 正在派送订单</el-menu-item
            >
            <el-menu-item index="/deliveryOrder/accomplish"
              >• 已派送订单</el-menu-item
            >
          </el-submenu>
          <el-submenu index="/SeniorAaccount" v-if="account">
            <template slot="title">
              <i class="el-icon-s-marketing"></i>
              <span>高级账户</span>
            </template>
            <el-menu-item index="/SeniorAaccount/inquire"
              >• 查单管理</el-menu-item
            >
            <el-menu-item index="/SeniorAaccount/pickUp"
              >• 提货管理</el-menu-item
            >
            <el-menu-item index="/SeniorAaccount/delivery"
              >• 待派送管理</el-menu-item
            >
            <el-menu-item index="/SeniorAaccount/billingSystem"
              >• 账单系统</el-menu-item
            >
          </el-submenu>
          <el-menu-item index="/flight/flight">
            <i class="el-icon-s-data"></i>
            <span slot="title">进度查询</span>
          </el-menu-item>
          <el-menu-item index="/visit/visit">
            <i class="el-icon-s-comment"></i>
            <span slot="title">预约上门</span>
          </el-menu-item>
          <el-submenu index="/userInfo">
            <template slot="title">
              <i class="el-icon-s-custom"></i>
              <span>个人中心</span>
            </template>
            <el-menu-item index="/userInfo/userInfo">
              <span slot="title">个人中心</span>
            </el-menu-item>
            <el-menu-item index="/userInfo/bill">
              <span slot="title">账单中心</span>
            </el-menu-item>
            <el-menu-item index="/userInfo/address">收件人管理</el-menu-item>
              <el-menu-item index="/userInfo/recharge">账户充值</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import crudDept from "../api/userMG";
import Cookies from "js-cookie";
export default {
  inject: ["reload"],
  name: "leftnav",
  data() {
    return {
      sendGoods: 0,
      confirmedNum: 0,
      getWarehousesNumber: 0,
      selectReturnOrderDatas: "",
      show1: false,
      orderNumbers: "",
      pageRouter: "",
      account: false,
      isCollapse: false,
      collapsed: false,
      allmenu: [],
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.$root.Bus.$on("toggle", (value) => {
      this.collapsed = !value;
    });
    this.orderNumber();
    this.selectReturnOrderData();
    this.circuit1();
    this.warehouse();
    this.circuit2();
    this.user();
  },
  methods: {
    user() {
      if (typeof Cookies.get("logistics_user") == "string") {
        var logistics_user = JSON.parse(Cookies.get("logistics_user"));
      } else {
        var logistics_user = Cookies.get("logistics_user");
      }
      var data = {
        id: logistics_user.id,
      };
      crudDept.user(data).then((res) => {
        if (res.content[0].role == 3) {
          this.account = false;
        } else {
          this.account = true;
        }
      });

      // var logistics_user = JSON.parse(Cookies.get("logistics_user"));
      // console.log(logistics_user,'ddddddddddddddddddddd')
      // if(logistics_user.roles.length >= 2){
      //   this.account=true;
      // }else{
      //   this.account=false;
      // }
    },
    // 待确认包裹线路数量
    //线路
    circuit1() {
      var data = {
        page: this.page,
        size: 100,
        state: 60,
        grouptype: 25,
      };
      crudDept.gerRouteNumber(data).then((res) => {
        var data1 = 0;
        var data2 = 0;
        for (var i = 0; i < res.content.length; i++) {
          if (res.content[i].type == 1 || res.content[i].type == 4) {
            data1 += res.content[i].ordernumber;
          } else if (res.content[i].type == 2 || res.content[i].type == 3) {
            data2 += res.content[i].batchnumber;
          }
        }
        this.confirmedNum = data1 + data2;
      });
    },
    //待发货订单数量
    circuit2() {
      var data = {
        page: 1,
        size: 100,
        state: 10,
        grouptype: 15,
      };
      crudDept.gerRouteNumber(data).then((res) => {
        var data3 = 0;
        for (var i = 0; i < res.content.length; i++) {
          data3 += res.content[i].ordernumber;
        }
        this.sendGoods = data3;
      });
    },
    //未匹配仓库订单数量
    warehouse() {
      var data = {
        state: 0,
      };
      crudDept.getWarehousesNumber(data).then((res) => {
        this.warehouseList = res.content;
        var getWarehousesNumber = 0;
        for (var i = 0; i < res.content.length; i++) {
          getWarehousesNumber += res.content[i].ordernumber;
        }
        this.getWarehousesNumber = getWarehousesNumber;
      });
    },
    handleSelect(index) {
      //console.log(index);
      this.pageRouter = index;
      if (index === this.$route.path) {
        this.reload();
      }
    },
    selectReturnOrderData() {
      var data = {};
      crudDept.selectReturnOrderData(data).then((res) => {
        this.selectReturnOrderDatas = res;
      });
    },
    orderNumber() {
      var data = {};
      crudDept.orderNumber(data).then((res) => {
        this.orderNumbers = res;
      });
    },
  },
};
</script>
<style>
.spans {
  display: flex;
  align-items: center;
  /* justify-content: center; */
}
.el-badge__content {
  background-color: #ff6003;
}
.el-badge__content.is-fixed {
  top: 50%;
  right: -5px;
}
/* .icon{
  width: 20px;
  height: 20px;
}
.enu_item {
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: center;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #fff !important;
}
.el-menu {
  border: none;
}
.bgc_box {
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}
.logoimg {
  height: 40px;
}
.el-submenu .el-menu-item {
  border-radius: 26px;
}
.el-row {
  padding: 0 20px;
  box-sizing: border-box;
}
.el-submenu {
  border-radius: 26px;
}
.el-menu-item {
  border-radius: 26px;
}
.el-submenu__title {
  border-radius: 26px;
}

.el-menu-item.is-active {
  background-color: #5178ff !important;
  border-radius: 26px;
  color: #fff;
  box-sizing: border-box;
}
.el-menu-item,
.el-submenu__title {
  min-width: 0 !important;
  height: 40px !important;
  line-height: 40px !important;
  margin-bottom: 10px;

}
.el-menu-item {
}
.el-submenu .el-menu-item {
  min-width: 0 !important;
  height: 40px !important;
text-align: center !important;
  line-height: 40px !important;
  padding: 0 !important;
} */
.logoBox {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
  /* justify-content: center; */
}
.logo1 {
  width: 38px;
  height: 36px;
  margin-right: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue